import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { useCustWhOptionsQuery } from "hooks/useQueryHook";
import { useLocationOptionsQuery } from "hooks/useLocationQuery";
import { useUOMOptionsQuery } from "hooks/useUOMQuery";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useState } from "react";
import { TitleField } from "ui-components/Form";

import { FormTitle, Text, SelectField } from "ui-components/Form";

function VendorSKUInfo({
  values = {},
  skuOptions = [],
  vendorOptions = [],
  formRender,
  setValue,
  control,
  errors,
  mode = "ADD",
}) {
  const [whOptions, setWHOptions] = useState([]);
  const [defRecvZoneOpt, setDefRecvZoneOpt] = useState([]);
  const [defRecvLocationOpt, setDefRecvLocationOpt] = useState([]);
  const [defTRPutawayZoneOpt, setDefTRPutawayZoneOpt] = useState([]);
  const [defTRPutawayLocationOpt, setDefTRPutawayLocationOpt] = useState([]);
  const [defPutawayZoneOpt, setDefPutawayZoneOpt] = useState([]);
  const [defPutawayLocationOpt, setDefPutawayLocationOpt] = useState([]);
  const [defShipZoneOpt, setDefShipZoneOpt] = useState([]);
  const [defShipLocationOpt, setDefShipLocationOpt] = useState([]);
  useCustWhOptionsQuery({
    customerCode: values.customerCode,
    onSuccess: (data) => setWHOptions(data.data.data),
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defRecvWh",
    whCode: values.defRecvWh,
    zoneType: "staging",
    onSuccess: (data) => setDefRecvZoneOpt(data.data.data),
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defPutawayWh",
    whCode: values.defPutawayWh,
    zoneType: "storage",
    onSuccess: (data) => setDefPutawayZoneOpt(data.data.data),
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defTRPutawayWh",
    whCode: values.defTRPutawayWh,
    zoneType: "return",
    onSuccess: (data) => setDefTRPutawayZoneOpt(data.data.data),
  });
  useZoneOptionsQuery({
    queryKey: "zone-options-defShipWh",
    whCode: values.defShipWh,
    zoneType: "shipping",
    onSuccess: (data) => setDefShipZoneOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defRecvWh",
    whCode: values.defRecvWh,
    zoneID: values.defRecvZone,
    onSuccess: (data) => setDefRecvLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defPutawayWh",
    whCode: values.defPutawayWh,
    zoneID: values.defPutawayZone,
    onSuccess: (data) => setDefPutawayLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defTRPutawayWh",
    whCode: values.defTRPutawayWh,
    zoneID: values.defTRPutawayZone,
    onSuccess: (data) => setDefTRPutawayLocationOpt(data.data.data),
  });
  useLocationOptionsQuery({
    queryKey: "location-options-defShipWh",
    whCode: values.defShipWh,
    zoneID: values.defShipZone,
    onSuccess: (data) => setDefShipLocationOpt(data.data.data),
  });
  const onSelectChange = (name, option) => {
    setValue(name, option);

    switch (name) {
      case "skuCode":
        setValue("vendorSKU", option);
        break;
      case "defRecvWh":
        setValue("defRecvZone", null);
        setValue("defRecvLocation", null);
        setDefRecvZoneOpt([]);
        setDefRecvLocationOpt([]);
        break;
      case "defRecvZone":
        setValue("defRecvLocation", null);
        setDefRecvLocationOpt([]);
        break;
      case "defTRPutawayWh":
        setValue("defTRPutawayZone", null);
        setValue("defTRPutawayLocation", null);
        setDefTRPutawayZoneOpt([]);
        setDefTRPutawayLocationOpt([]);
        break;
      case "defTRPutawayZone":
        setValue("defTRPutawayLocation", null);
        setDefTRPutawayLocationOpt([]);
        break;
      case "defPutawayWh":
        setValue("defPutawayZone", null);
        setValue("defPutawayLocation", null);
        setDefPutawayZoneOpt([]);
        setDefPutawayLocationOpt([]);
        break;
      case "defPutawayZone":
        setValue("defPutawayLocation", null);
        setDefPutawayLocationOpt([]);
        break;
      case "defShipWh":
        setValue("defShipZone", null);
        setValue("defShipLocation", null);
        setDefShipZoneOpt([]);
        setDefShipLocationOpt([]);
        break;
      case "defShipZone":
        setValue("defShipLocation", null);
        setDefShipLocationOpt([]);
        break;
    }
  };
  return (
    <MDBox>
      <FormTitle
        title={mode === "EDIT" ? "Edit Vendor SKU Information" : "Vendor SKU Information"}
      />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { disabled, editable, ...data } = property;
              const xs = 6 / 2;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(disabled && { disabled }),
                ...(mode === "EDIT" && editable === false && { disabled: true, type: "text" }),
              };
              let renderField;
              switch (fieldProps.type) {
                case "text":
                case "number":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  let onChange = null;
                  switch (data.name) {
                    case "skuCode":
                      options = skuOptions;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;
                    case "vendorCode":
                      options = vendorOptions;
                      break;
                    case "defRecvWh":
                    case "defTRPutawayWh":
                    case "defPutawayWh":
                    case "defShipWh":
                      options = whOptions;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;

                    case "defRecvZone":
                      options = defRecvZoneOpt;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;
                    case "defRecvLocation":
                      options = defRecvLocationOpt;
                      break;
                    case "defTRPutawayZone":
                      options = defTRPutawayZoneOpt;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;
                    case "defTRPutawayLocation":
                      options = defTRPutawayLocationOpt;
                      break;
                    case "defPutawayZone":
                      options = defPutawayZoneOpt;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;
                    case "defPutawayLocation":
                      options = defPutawayLocationOpt;
                      break;
                    case "defShipZone":
                      options = defShipZoneOpt;
                      onChange = (e, option) => onSelectChange(data.name, option);
                      break;
                    case "defShipLocation":
                      options = defShipLocationOpt;
                      break;
                  }
                  renderField = (
                    <SelectField field={fieldProps} options={options} onChange={onChange} />
                  );
                  break;
                case "title":
                  renderField = <TitleField label={data.label} />;
                  break;
              }

              return (
                <Grid item xs={xs} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default VendorSKUInfo;
